import client, { requestConfig } from "./client";

const endpoint = "/api/event-tags";

const get = () => client.get(endpoint, {}, requestConfig());

export default {
  get,
};
